import React, { SVGProps } from 'react';

export const LogoutIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M16.1249 12.0001C16.1249 11.8012 16.0459 11.6104 15.9053 11.4698C15.7646 11.3291 15.5739 11.2501 15.3749 11.2501H4.40195L6.36295 9.57012C6.4378 9.50603 6.4993 9.42783 6.54393 9.33998C6.58856 9.25213 6.61545 9.15635 6.62307 9.0581C6.63068 8.95986 6.61887 8.86108 6.58831 8.7674C6.55775 8.67372 6.50903 8.58697 6.44495 8.51212C6.38086 8.43727 6.30266 8.37577 6.21481 8.33114C6.12696 8.28651 6.03117 8.25961 5.93293 8.252C5.83469 8.24439 5.7359 8.2562 5.64222 8.28676C5.54854 8.31732 5.4618 8.36603 5.38695 8.43012L1.88695 11.4301C1.80461 11.5005 1.73851 11.5879 1.69318 11.6863C1.64786 11.7847 1.62439 11.8918 1.62439 12.0001C1.62439 12.1085 1.64786 12.2155 1.69318 12.3139C1.73851 12.4123 1.80461 12.4997 1.88695 12.5701L5.38695 15.5701C5.53812 15.6995 5.73452 15.7636 5.93293 15.7482C6.13134 15.7329 6.31552 15.6393 6.44495 15.4881C6.57437 15.3369 6.63844 15.1405 6.62307 14.9421C6.60769 14.7437 6.51412 14.5595 6.36295 14.4301L4.40295 12.7501H15.3749C15.5739 12.7501 15.7646 12.6711 15.9053 12.5304C16.0459 12.3898 16.1249 12.199 16.1249 12.0001Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M9.375 8C9.375 8.702 9.375 9.053 9.544 9.306C9.61679 9.41478 9.71022 9.50821 9.819 9.581C10.072 9.75 10.423 9.75 11.125 9.75H15.375C15.9717 9.75 16.544 9.98705 16.966 10.409C17.3879 10.831 17.625 11.4033 17.625 12C17.625 12.5967 17.3879 13.169 16.966 13.591C16.544 14.0129 15.9717 14.25 15.375 14.25H11.125C10.423 14.25 10.072 14.25 9.819 14.418C9.71012 14.4911 9.61668 14.5849 9.544 14.694C9.375 14.947 9.375 15.298 9.375 16C9.375 18.828 9.375 20.243 10.254 21.121C11.132 22 12.546 22 15.374 22H16.374C19.204 22 20.617 22 21.496 21.121C22.375 20.243 22.375 18.828 22.375 16V8C22.375 5.172 22.375 3.757 21.496 2.879C20.617 2.001 19.203 2 16.375 2H15.375C12.546 2 11.132 2 10.254 2.879C9.375 3.757 9.375 5.172 9.375 8Z"
        fill="currentColor"
      />
    </svg>
  );
};
